import { render, staticRenderFns } from "./OldView.vue?vue&type=template&id=196f92f0"
import script from "./OldView.vue?vue&type=script&lang=js"
export * from "./OldView.vue?vue&type=script&lang=js"
import style0 from "./OldView.vue?vue&type=style&index=0&id=196f92f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports